import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Image from 'react-image'
import LoadImage from 'assets/images/loading-image.gif'
import NewFile from 'assets/images/new-file-simple-md.png'
import ThumbnailLoader from 'components/shared/loaders/thumb'
import { reduxForm, Field, formValueSelector, change } from 'redux-form'
import * as types from 'actions/messages/types'
import Attachement from 'forms/shared/fields/attachment'

const MessageBox = ({
  id,
  handleSubmit,
  onSubmit,
  conversationTyping,
  conversationBlur,
  attachment,
  reset,
  typingName,
  typingId,
  handleMessageOrProposal,
  proposalDetail,
  form,
  dispatch,
}) => {
  const handleClick = () => {
    const data = {
      proposalId: proposalDetail.proposal_id,
      action: 'view-proposal',
    }
    handleMessageOrProposal(data)
  }
  const [attachmentProcessing, setAttachmentStatus] = useState(false)
  const getAttachmentStatus = (status) => setAttachmentStatus(status)

  const handleChange = (value) => {
    if (value) {
      conversationTyping({ id, typingName, typingId })
    } else {
      conversationBlur({ typingId })
    }
  }
  const msgField = useRef()
  const handleRemoveAttachment = (index) => {
    const newAttachment = attachment
    newAttachment.splice(index, 1)
    dispatch(change(form, 'attachment', newAttachment))
  }
  return (
    <div>
      {proposalDetail && (
        <div className="border lg:p-5 p-2 text-white shadow block">
          <span
            onClick={() => handleClick()}
            className="cursor-pointer text-orange-500 text-sm font-medium"
          >
            VIEW PROPOSAL
          </span>
        </div>
      )}
      {attachment.length > 0 && (
        <div className="attachment attachment-container w-full max-h-max flex-wrap border flex">
          {attachment.map((file, key) => {
            const isImage = !file.type || file.type.indexOf('image') > -1
            return (
              <div className="h-48 w-48 p-2 flex flex-col items-center" key={key}>
                <div className="w-max max-h-max p-3 border border-dashed rounded relative">
                  {isImage && (
                    <Image
                      src={[file.path, LoadImage]}
                      alt={file.name}
                      className="h-32 w-32 object-cover rounded"
                      loader={<ThumbnailLoader />}
                    />
                  )}
                  {!isImage && (
                    <Image
                      src={file.path ? NewFile : LoadImage}
                      alt={file.name}
                      className={`h-32 ${file.path ? 'w-auto' : 'w-32'} object-cover rounded`}
                      loader={<ThumbnailLoader />}
                    />
                  )}
                  <div className="absolute right-0 top-0 leading-none">
                    <i
                      onClick={() => handleRemoveAttachment(key)}
                      className="fa fa-minus-circle text-xl cursor-pointer text-red-600"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div className="w-full truncate text-xs text-center text-primary-darkgray">
                  {file.name}
                </div>
              </div>
            )
          })}
        </div>
      )}
      <form
        onSubmit={handleSubmit((values) => {
          onSubmit(values)
          reset()
        })}
        name="send-message-form"
      >
        <div className="flex items-center">
          <Field
            ref={msgField}
            onBlur={() => conversationBlur({ typingId })}
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Your message goes directly to the Space Operators - make sure to include as many details as possible!"
            name="message"
            rows="4"
            className="message-box-area auto-size focus:outline-none focus:bg-white bg-gray-100 border p-1 w-full px-5 py-3"
            component="textarea"
          />
        </div>
        <div className="flex items-center justify-between md:p-5 p-1">
          <Field
            formName={form}
            name="attachment"
            type="file"
            label="ATTACH FILES"
            component={Attachement}
            getStatus={getAttachmentStatus}
            acceptedFiles="image/jpg, image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
          <button
            disabled={attachmentProcessing}
            className="rounded bg-orange-400 text-white py-2 px-5 text-sm ml-2 font-medium"
          >
            Send
          </button>
        </div>
      </form>
    </div>
  )
}

MessageBox.propTypes = {
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func,
  messages: PropTypes.array,
  form: PropTypes.string,
  reset: PropTypes.func,
  typingName: PropTypes.string,
  typingId: PropTypes.number,
  conversationBlur: PropTypes.func,
  typings: PropTypes.array,
  conversationTyping: PropTypes.func,
  id: PropTypes.number,
  handleMessageOrProposal: PropTypes.func,
  proposalDetail: PropTypes.object,
  attachment: PropTypes.array,
  dispatch: PropTypes.func,
}

const mapStateToProps = ({ ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    attachment: selector(state, 'attachment') || [],
  }
}

const mapDispatchToProps = (dispatch) => ({
  conversationTyping: (payload) => dispatch({ type: types.CONVERSATION_TYPING, payload }),
  conversationBlur: (payload) => dispatch({ type: types.CONVERSATION_BLUR, payload }),
  dispatch,
})

export default reduxForm({})(connect(mapStateToProps, mapDispatchToProps)(MessageBox))
